module.exports = "/images/Lithuania.png?91ac7242390253c9f5d653844d252f91";